import Vue from 'vue'

Vue.config.productionTip = false

let user_center_menu = {
  name: 'user-center-menu',
  data: () => {
    return {
      selected_item: null
    }
  },
  mounted () {
    this.getURL()
  },
  methods: {
    handleClick (e) {
      this.selected_item = e.key
      this.$router.push({name: e.key})
    },
    getURL () {
      let key = window.location.href.split('usercenter/')[1]
      this.selected_item = key
    }
  }
}
export default user_center_menu



// WEBPACK FOOTER //
// ./src/user_center/js/user_center_menu.js